export const useNotificationPermission = () => {
    const checkNotificationPermission = (): NotificationPermission | 'unsupported' => {
        if ('Notification' in window) {
            // 'granted' | 'denied' | 'default'
            return Notification.permission
        }
        return 'unsupported'
    }

    return {
        checkNotificationPermission,
    }
}
